import { ToastContainer as ReactToastContainer } from 'react-toastify';

const ToastContainer = () => {

  return <ReactToastContainer limit={3} position="top-right" theme='light' />;
};

export default ToastContainer;
